import { Checkbox, IconButton, TableCell, TableRow } from '@material-ui/core';
import { GetApp, KeyboardArrowDown, KeyboardArrowUp, Visibility } from '@material-ui/icons';
import React, { useState } from 'react'
import CustomButton from './CusomButton';
import CollapsibleRow from './CollapsibleRow';
import CDMOCollapsibleRow from './CDMOCollapsibleRow';
import BatchDetails from './BatchDetails';
import ExceptionDetails from './ExceptionDetails';
import BatchDetailsUnitBox from './dropdownComponents/BatchDetailsUnitBox';
import moment from 'moment';
import CreateIcon from "@material-ui/icons/Create";

const DropdownRow = ({ row, index, projectData, workItemDetails, deliverablesData, openDialogBoxType, setDialogBox }) => {
    const [open, setOpen] = useState(false);
    return (
        <>
          <TableRow style={index % 2 !== 0 ? { backgroundColor: "#F9F9FC" } : {}}>
            <TableCell>
              <IconButton onClick={() => setOpen(!open)}>
                {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
              </IconButton>
            </TableCell>
            <TableCell style={{ minWidth: "200px" }}>
              {row.workItemDescription}
            </TableCell>
            <TableCell>
              {moment(row.scheduledDeliveryDate).format("DD-MMM-YYYY").toUpperCase()}
            </TableCell>
            <TableCell>
              {moment(row.actualDeliveryDate).format("DD-MMM-YYYY").toUpperCase()}
            </TableCell>
            <TableCell>{row.workItemStatus}</TableCell>
            <TableCell align="center">
              <Checkbox checked={row.qaApprovalRequired} />
            </TableCell>
            <TableCell align="center" style={{ minWidth: "430px" }}>
              <IconButton>
                <Visibility />
              </IconButton>
              <IconButton>
                <GetApp />
              </IconButton>
              {/* <CustomButton
                hasBorder={true}
                onClick={() => openViewCommentsDialog(row.collabrixWorkItemID)}
              >
                View Comments
              </CustomButton> */}
              <CustomButton
                hasBorder={true}
                style={{ marginLeft: "8px" }} // Add margin to separate the buttons
              >
                View Remarks
              </CustomButton>
              <IconButton>
                <CreateIcon />
              </IconButton>
            </TableCell>
          </TableRow>
          {open && row?.workItemTypeID === 2 && (
            localStorage.collabType !== 'CMO' ?
            <CollapsibleRow
              open={open}
              projectData={projectData}
              workItemDetails={workItemDetails}
              deliverablesData={deliverablesData}
              row={row}
              handleSuccessDialog={(type, documentDetails) => {
                // console.log(type)
                if (type === 'verifyElectronicSignature') {
                  setDialogBox({ ...openDialogBoxType, openElectronicSignDialog: true, dialogBoxType: type, documentDetails: documentDetails ? documentDetails:'' })
  
                } else {
                  setDialogBox({ ...openDialogBoxType, openSuccessDialogBox: true, dialogBoxType: type, documentDetails: documentDetails ? documentDetails:'' })
                }
              }
              }
            />
              :
            <CDMOCollapsibleRow
              open={open}
              projectData={projectData}
              workItemDetails={workItemDetails}
              deliverablesData={deliverablesData}
              row={row}
              handleSuccessDialog={(type, documentDetails) => {
                if (type === 'verifyElectronicSignature') {
                  setDialogBox({ ...openDialogBoxType, openElectronicSignDialog: true, dialogBoxType: type, documentDetails: documentDetails ? documentDetails:'' })
  
                } else {
                  setDialogBox({ ...openDialogBoxType, openSuccessDialogBox: true, dialogBoxType: type, documentDetails: documentDetails ? documentDetails:'' })
                }
              }
              }
            />
          )}
  
          {open && row?.workItemTypeID === 4 && (
            <BatchDetails
              projectData={projectData}
              open={open}
              workItemDetails={row}
            />
          )}
          {open && row?.workItemTypeID === 6 && (
            <ExceptionDetails
              open={open}
              projectData={projectData}
              workItemDetails={workItemDetails}
              deliverablesData={deliverablesData}
              row={row}
              addException={true}
            />
          )}
          {open && row?.workItemTypeID === 7 && (
            <ExceptionDetails
              open={open}
              projectData={projectData}
              workItemDetails={workItemDetails}
              deliverablesData={deliverablesData}
              row={row}
              addException={false}
            />
          )}
          {open && row?.workItemTypeID === 3 && (
            <BatchDetailsUnitBox open={open} workitemData={row} />
          )}
          {open && row?.workItemTypeID === 5 && (
            <BatchDetailsUnitBox open={open} workitemData={row} sample={true} />
          )}
        </>
      );
}

export default DropdownRow